module.exports = __webpack_public_path__ + "static/media/cloud-file-gray.ff61c3cb.svg";